import { usePortal } from '@/features/notifications/components/NotificationCenter/contexts/Portal'
import { useCloseOnNavigationEvent } from '@/features/notifications/components/NotificationCenter/hooks/useCloseOnNavigationEvent'
import Paper from '@/features/notifications/components/NotificationCenter/parts/Paper'
import PaperWrapper from '@/features/notifications/components/NotificationCenter/parts/PaperWrapper/PaperWrapper'
import ToggleButton from '@/features/notifications/components/NotificationCenter/parts/ToggleButton'
import { ReadNotifications } from '@/features/notifications/components/NotificationCenter/types'
import { Notification } from '@/features/notifications/notification-service-extension-shared/types/app'
import { FC, useMemo, useRef } from 'react'
import { StyleProp, View, ViewStyle } from 'react-native'

interface NotificationCenterProps {
    opened: boolean
    notifications: Notification[]
    readNotifications: ReadNotifications
    toggle: () => void
    toggleButtonStyle?: StyleProp<ViewStyle>
}

const NotificationCenter: FC<NotificationCenterProps> = ({
    opened,
    notifications,
    readNotifications,
    toggle,
    toggleButtonStyle,
}) => {
    const toggleButtonRef = useRef<View>(null)

    const memoizedPaper = useMemo(
        () => (
            <PaperWrapper>
                <Paper
                    notifications={notifications}
                    readNotifications={readNotifications}
                    close={toggle}
                    anchorRef={toggleButtonRef}
                />
            </PaperWrapper>
        ),
        [notifications, readNotifications, toggle]
    )

    usePortal(opened, memoizedPaper)

    useCloseOnNavigationEvent(opened, toggle)

    const count = Math.max(notifications.length - Object.keys(readNotifications).length, 0)

    return (
        <ToggleButton
            active={opened}
            count={count}
            onPress={toggle}
            ref={toggleButtonRef}
            style={toggleButtonStyle}
        />
    )
}

export default NotificationCenter
